var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-bottom-container"},[_c('div',{staticClass:"footer-bottom-con"},[_c('span',[_vm._v("版权所有©1996-2021 天津市旅游（控股）集团有限公司")]),_c('span',[_c('span',{staticClass:"jicon"}),_vm._v(" 津公网安备 12010302001487号 ")]),_c('span',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/recordQuery"}},[_vm._v("津ICP备13005272号-1")])])])])
}]

export { render, staticRenderFns }